import block from "./block";
import component from "./component";

export default (editor, opts = {}) => {
  editor.DomComponents.addType("checkList", component(opts));
  editor.BlockManager.add("checkList", block(opts));
};